import {
	ReferredUserResponse,
	CreateReferralLinkDto,
	CreateReferralLinkResponse,
	SaveReferralFingerprintDto,
	GetReferralByFingerprintDto,
	SaveReferralFingerprintResponse,
	GetReferralByFingerprintResponse,
	ReferralLinkResponse,
} from '@sportspredict/shared';
import api from './base-api';

const referralApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		saveReferralFingerprint: builder.mutation<
			SaveReferralFingerprintResponse,
			SaveReferralFingerprintDto
		>({
			query: (data) => ({
				url: 'referral-links/fingerprint',
				method: 'POST',
				body: data,
			}),
			extraOptions: { skipAuth: true },
		}),
		getReferralCodeByFingerprint: builder.mutation<
			GetReferralByFingerprintResponse,
			GetReferralByFingerprintDto
		>({
			query: (data) => ({
				url: 'referral-links/fingerprint/lookup',
				method: 'POST',
				body: data,
			}),
			extraOptions: { skipAuth: true },
		}),
		getReferralLink: builder.mutation<ReferralLinkResponse | null, { referralCode: string }>({
			query: (data) => ({
				url: 'referral-links/info',
				method: 'POST',
				body: data,
			}),
			extraOptions: { skipAuth: true },
		}),
		cleanupReferralFingerprint: builder.mutation<void, SaveReferralFingerprintDto>({
			query: (data) => ({
				url: 'referral-links/fingerprint/cleanup',
				method: 'POST',
				body: data,
			}),
			extraOptions: { skipAuth: true },
		}),
		// PRIVATE
		createReferralLink: builder.mutation<CreateReferralLinkResponse, CreateReferralLinkDto>({
			query: (data) => ({
				url: 'referral-links',
				method: 'POST',
				body: data,
			}),
		}),
		getReferredUsers: builder.query<ReferredUserResponse[], void>({
			query: () => ({
				url: 'referral-links/referrals',
				method: 'GET',
			}),
		}),
	}),
});

export default referralApi;

export const {
	useCreateReferralLinkMutation,
	useGetReferredUsersQuery,
	useSaveReferralFingerprintMutation,
	useGetReferralCodeByFingerprintMutation,
	useGetReferralLinkMutation,
	useCleanupReferralFingerprintMutation,
} = referralApi;
